import React, { useEffect, useState } from 'react';
import { API_URL } from '~/src/utils/constants';
import FormRow from '~/src/components/common/forms/Row/FormRow';
import TextInputComponent from '~/src/components/common/forms/TextInput/TextInputComponent';
import AutocompletePaginatedComponent from './forms/Autcomplete/AutocomplitePaginatedComponent';

interface AddressInputProps {
  values: {
    postCode: string;
    street: string;
    buildNumber: string;
    state: string;
    countryId: string;
    cityId: string;
  };
  errors: {
    postCode?: string;
    street?: string;
    buildNumber?: string;
    state?: string;
    countryId?: string;
    cityId?: string;
  };
  setFieldValue: (field: string, value: any) => void;
  handleBlur: (e: React.FocusEvent<any>) => void;
  handleChange: (e: React.ChangeEvent<any>) => void;
}

export default function AddressInputComponent({
  values,
  errors,
  setFieldValue,
  handleBlur,
  handleChange,
}: AddressInputProps): JSX.Element {

  const [selectedCountryName, setSelectedCountryName] = useState<string | null>(null);

  useEffect(() => {
    if (!values.countryId) {
      setFieldValue('cityId', '');
      values.cityId = '';
    }
  }, [values.countryId]);

  return (
    <>
      <FormRow>
        <TextInputComponent
          name="postCode"
          label="Post Code"
          value={values.postCode}
          onBlur={handleBlur}
          onChange={handleChange}
          cols={12}
        />
      </FormRow>
      <FormRow>
        <TextInputComponent
          name="street"
          label="Street"
          value={values.street}
          onBlur={handleBlur}
          onChange={handleChange}
          cols={12}
          errors={errors}
        />
      </FormRow>
      <FormRow>
        <TextInputComponent
          name="buildNumber"
          label="Build Number"
          value={values.buildNumber}
          onBlur={handleBlur}
          onChange={handleChange}
          cols={12}
          errors={errors}
        />
      </FormRow>
      <FormRow>
        <AutocompletePaginatedComponent
          url={`${API_URL}/countries/get`}
          name="countryId"
          initialValue={values.countryId}
          onChange={(name, value) => {
            setFieldValue(name, value);
            setFieldValue('state', '');
            setSelectedCountryName(null);
          }}
          getOptionLabel={(option) => {
            setSelectedCountryName(option.name);
            return `${option.name}`;
          }}
          errorMessage={errors.countryId}
          cols={12}
          label="Country"
        />
      </FormRow>
      {selectedCountryName === 'United States of America (the)' && (
        <FormRow>
          <TextInputComponent
            key={values.countryId}
            name="state"
            label="State"
            value={values.state}
            onBlur={handleBlur}
            onChange={handleChange}
            cols={12}
            errors={errors}
          />
        </FormRow>
      )}
      <FormRow>
        <AutocompletePaginatedComponent
          key={values.countryId}
          url={`${API_URL}/addresses/cities/get-all`}
          name="cityId"
          initialValue={values.cityId}
          onChange={(name, value) => setFieldValue(name, value)}
          getOptionLabel={(option) => `${option.name}`}
          errorMessage={errors.cityId}
          cols={12}
          label="City"
          disabled={!values.countryId}
          additionalFilters={{ countryId: values.countryId }}
        />
      </FormRow>
    </>
  );
}